'use client'

import { InfoIcon } from 'lucide-react'

import { cn } from '@/_lib/utils'
import { useOrderFlow } from '@/app/[locale]/order/_context/order-flow-context'
import { getOrderThemeClasses } from '@/app/[locale]/order/_utils/order-flow-section-theme-classes'

type APatientInfoInsuranceDescriptionCalloutProps = {
	description: string
}

export function APatientInfoInsuranceDescriptionCallout({
	description
}: APatientInfoInsuranceDescriptionCalloutProps) {
	const { orderFlowSectionTheme } = useOrderFlow()

	return (
		<div
			className={cn(
				'mb-6 flex items-start gap-2 whitespace-pre-line rounded-xl px-4 py-5 text-sm',
				getOrderThemeClasses(orderFlowSectionTheme).surface
			)}
		>
			<div>
				<InfoIcon className='mt-0.5 h-5 w-5 text-medante-purple-dark/80' />
			</div>
			<span className='text-medante-purple-dark'>{description}</span>
		</div>
	)
}
